import Link from 'components/link/Link';
import Heading from 'components/heading/Heading';
import RichText from 'components/rich-text/RichText';

import { IContactListItem } from 'source/NFR.types';

const ContactListItem: React.FC<IContactListItem> = ({ title, contactText, contactLists = [], onPageEditing }) => {
  return (
    <div className="contact-list-item">
      {title && (
        <Heading className="contact-list-item--title" onPageEditing={onPageEditing?.title}>
          {title}
        </Heading>
      )}
      {contactText && <RichText {...contactText} />}
      {contactLists?.map(({ name, email, phone, contactUrl }, index) => {
        const contactUrlOnly = contactUrl && !name && !email && !phone;

        return (
          <div
            className={`contact-list-item--info ${contactUrlOnly ? 'contact-list-item--info__contact-url-only' : ''}`}
            key={name?.text || contactUrl?.url || email?.url || phone?.url || index}
          >
            <div className="contact-list-item--info__name">
              {name?.text && <span>{name.text}</span>}
              {name?.position && <div>{name.position}</div>}
            </div>
            {email && (
              <div className="contact-list-item--info__email">
                <Link {...email} theme="small" />
              </div>
            )}
            {phone && (
              <div className="contact-list-item--info__phone">
                <Link {...phone} theme="small" />
              </div>
            )}
            {contactUrl && (
              <div className="contact-list-item--info__link">
                <Link {...contactUrl} theme="small" />
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

ContactListItem.displayName = 'ContactListItem';

export default ContactListItem;
